import React, { useState, useRef, useEffect } from 'react';
import { IPage } from '../../interfaces/models/models/paginated-response.model';
import DropDown from '../dropdown';

interface ITable {
    columns?: Array<string>;
    selectRows?: boolean;
    children?: React.ReactNode;
    paginationData?: IPage;
    setPaginationState?: any;
    paginationState?: any;
    containerStyle?: string;
    sortColumns?: Array<string>;
    headerColsStyle?: string;
    onClickSortColumn?: (name: string) => void;
    onClickSelectAll?: () => void;
    areAllRowsSelected?: boolean;
    sortStatus?: any;
}

const itemsPerPage = [5, 10, 15, 20]

const TableNext = ({
    columns,
    selectRows,
    children,
    paginationData,
    setPaginationState,
    paginationState,
    containerStyle,
    sortColumns,
    headerColsStyle,
    onClickSortColumn,
    onClickSelectAll,
    areAllRowsSelected,
    sortStatus,
}: ITable) => {
    const [showDropDown, setShowDropDown] = useState<boolean>(false)
    const [showDropDownScnd, setShowDropDownScnd] = useState<boolean>(false)
    const node = useRef() as React.MutableRefObject<HTMLInputElement>;
    const nodeScnd = useRef() as React.MutableRefObject<HTMLInputElement>;

    const clickOutsideFirstDropDown = (e: any) => {
        if (node?.current?.contains(e.target)) {
            setShowDropDown(true)
            return;
        }
        setShowDropDown(false)
    }

    const clickOutsideScndDropDown = (e: any) => {
        if (nodeScnd?.current?.contains(e.target)) {
            setShowDropDownScnd(true)
            return;
        }
        setShowDropDownScnd(false)
    }

    useEffect(() => {
        document.addEventListener('mousedown', clickOutsideFirstDropDown);
        return () => {
            document.removeEventListener('mousedown', clickOutsideFirstDropDown);
        }
    }, [showDropDown])

    useEffect(() => {
        document.addEventListener('mousedown', clickOutsideScndDropDown);
        return () => {
            document.removeEventListener('mousedown', clickOutsideScndDropDown);
        }
    }, [showDropDownScnd])

    const onChangeItemsPerPage = (item: number) => {
        setPaginationState({
            ...paginationState || {},
            pageNumber: '',
            pageSize: item,
        })
        setShowDropDown(false)
    }

    const onChangePage = (page?: string) => {
        if (page) {
            setPaginationState({
                ...paginationState || {},
                pageNumber: page,
                pageSize: paginationData?.size || 1
            })
            setShowDropDownScnd(false)
        } else {
            setPaginationState({
                ...paginationState || {},
                pageNumber: '',
                pageSize: paginationData?.size || 1
            })
            setShowDropDownScnd(false)
        }
    }

    return (
        <>
            <div className={`my-4 overflow-x-auto ${containerStyle}`}>
                <table data-qa='table-rows' className='w-full text-sm text-left text-gray-500'>
                    <thead className='text-s text-black bg-[#FAFAFA] '>
                        <tr>
                            {selectRows && <th scope='col' className='p-4'>
                                <div className='flex items-center'>
                                    <input
                                        checked={areAllRowsSelected || false}
                                        onChange={() => onClickSelectAll?.()}
                                        id='checkbox-all'
                                        type='checkbox'
                                        className='w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 accent-green-600 rounded focus:accent-green-600 focus:ring-2' />
                                    <label htmlFor='checkbox-all' className='sr-only'>checkbox</label>
                                </div>
                            </th>
                            }
                            {columns && columns?.length > 0 && columns?.map((column: string, idx: number) => {
                                const columnSorted = sortColumns && sortColumns?.length > 0 && sortColumns?.find((item) => item === column)
                                const rotateImage = (columnSorted && sortStatus?.[columnSorted] === 'desc') ? '!rotate-[0deg]' : (columnSorted && sortStatus?.[columnSorted] === 'asc' ? '!rotate-[-180deg]' : '!rotate-0')
                                return (
                                    <th key={idx} scope='col' className={`px-6 py-3 ${headerColsStyle || ''}`}>
                                        <div onClick={() => columnSorted && onClickSortColumn?.(column)} className={`flex flex-row items-center ${columnSorted && 'cursor-pointer'}`}>
                                            {column}
                                            {columnSorted && <img src={'/assets/table-actions/sort.svg'} className={`ml-1 min-w-[16px] w-[16px] ${rotateImage}`} />}
                                        </div>
                                    </th>
                                )
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {/* <tr className='bg-white border-b hover:bg-gray-50'> */}
                        {children}
                        {/* </tr> */}
                    </tbody>
                </table>

                <div className='bg-[#F0F0F0] sticky left-0 right-0 min-w-full flex flex-1 flex-row items-stretch justify-between pl-5 border-t-2 border-[#DCDCDD]'>
                    <div className='flex flex-row text-[#8F8F8F] font-medium text-sm divide-x-2 divide-[#DCDCDD]'>
                        <div className='py-2 pr-4 flex flex-row'>
                            <p>Items per page</p>
                            <div ref={node} className='relative flex flex-row text-black font-medium text-sm pl-3 cursor-pointer'>
                                <p>{paginationData?.size}</p>
                                <img alt='items arrow' src={'/assets/table-actions/arrow.svg'} className={'w-[12px] object-contain rotate-90 pl-[5px]'} />
                                <DropDown
                                    open={showDropDown}
                                    items={itemsPerPage}
                                    onClickItem={onChangeItemsPerPage} />
                            </div>
                        </div>
                        <div className='py-2 pr-4'>
                            <p className='px-4'>{paginationData?.totalElements} items</p>
                        </div>
                    </div>
                    <div className='flex flex-row text-[#8F8F8F] font-medium text-sm divide-x-2 divide-[#DCDCDD]'>
                        <div></div>
                        <div data-qa={'arrow-left'} onClick={() => onChangePage()} className='py-2 px-3 h-full flex flex-row items-center cursor-pointer hover:bg-stone-300'>
                            <img alt='previous' src={'/assets/table-actions/arrow.svg'} className={'w-[12px] object-contain rotate-180'} />
                        </div>
                        <div data-qa={'arrow-right'} onClick={() => paginationData?.hasNextPage && onChangePage(paginationData?.nextPage)} className='py-2 px-3 h-full flex flex-row items-center cursor-pointer hover:bg-stone-300'>
                            <img alt='next' src={'/assets/table-actions/arrow.svg'} className={'w-[12px] object-contain'} />
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
};

export default TableNext;